module.exports = __webpack_public_path__ + "static/media/gallery_sof.8c1aa4c1.png";